import React from "react";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import MainRoute from "./routes/MainRoute";

const queryClient = new QueryClient();

import "@coreui/coreui/dist/css/coreui.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <RecoilRoot>
          <BrowserRouter>
            <MainRoute />
          </BrowserRouter>
        </RecoilRoot>
      </div>
    </QueryClientProvider>
  );
};

export default App;
